module.exports = __webpack_public_path__ + "static/media/Holograma.7e923add.3gpp";